import { render } from "./table-select.vue?vue&type=template&id=2addfe77"
import script from "./table-select.vue?vue&type=script&lang=js"
export * from "./table-select.vue?vue&type=script&lang=js"

import "./table-select.vue?vue&type=style&index=0&id=2addfe77&lang=less"

import exportComponent from "F:\\code\\flash-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__